
   <template>
  <div>
    <!-- 新增按钮 -->
   <Select
          v-model="nstatus"
          placeholder="请选择审核状态"
          style="width: 200px; margin-right: 10px"
        >
          <Option value="">未选择</Option>
          <Option :value="0">待审核</Option>
          <Option :value="1">已通过</Option>
          <Option :value="2">已拒绝</Option>
        </Select>

        <Select
          v-model="ntype"
          placeholder="请选择类型状态"
          style="width: 200px; margin-right: 10px"
        >
          <Option value="">未选择</Option>
          <Option :value="0">收货实拍</Option>
          <Option :value="1">娃娃机出奖</Option>
          <Option :value="2">游戏出奖</Option>
        </Select>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal v-model="jpImageModal" title="查看图片" :footer-hide="true" width="700">
      <div style="text-align: center">
        <div v-if="jpImageLoading">加载中...</div>
        <img
          v-else-if="jpImageUrl"
          :src="jpImageUrl"
          style="max-width: 100%; max-height: 520px"
        />
        <div v-else>暂无图片</div>
      </div>
    </Modal>

    <Modal
      v-model="rejectModal"
      title="拒绝原因"
      width="700"
      @on-ok="submitReject"
      @on-cancel="cancelReject"
    >
      <div>
        <RadioGroup v-model="rejectReason">
          <Radio label="重复发布相同或相似内容">重复发布相同或相似内容</Radio>
          <Radio label="含联系方式、二维码或广告信息">含联系方式、二维码或广告信息</Radio>
          <Radio label="与自拍馆主题不符">与自拍馆主题不符</Radio>
          <Radio label="含低俗、暴露或不适宜展示内容">含低俗、暴露或不适宜展示内容</Radio>
          <Radio label="其他原因，不适宜展示，详情可咨询客服">其他原因，不适宜展示，详情可咨询客服</Radio>
        </RadioGroup>
      </div>
    </Modal>
 
  </div>
</template>

<script>
import { cmsShowList,cmsCleck } from "../../api/person";


import { formatOssUrl } from "@/utils";

export default {
  data() {
    return {
      selUser: {},
      modal4: false,
      modal3: false,
      modal2: false, // 控制充值弹窗的显示与否
      rechargeType: "充值", // 充值或扣除的类型，"recharge"表示充值，"deduct"表示扣除
      currencyType: "金币", // 选择的类型，可以是"points"或"coins"
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      giftId: "", // 添加礼品ID字段
      isfengjin: false,
      modal1: false,
      nstatus: "",
      ntype: "",
      jpImageModal: false,
      jpImageUrl: "",
      jpImageLoading: false,
      rejectModal: false,
      rejectReason: "",
      rejectRowId: null,
      roomid: "",
      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "昵称",
          key: "user_nickname",
          render: (h, params) => {
            const nickname =
              params.row && params.row.user ? params.row.user.user_nickname : "";
            return h("span", nickname);
          },
        },
        {
          title: "内容",
          key: "contenttxt",
        },
        {
          title: "审核状态",
          key: "nstatus",
          render: (h, params) => {
            const v = params.row ? params.row.nstatus : "";
            const text =
              v === 0 ? "待审核" : v === 1 ? "已通过" : v === 2 ? "已拒绝" : "";
            return h("span", text);
          },
        },
        {
          title: "类型",
          key: "ntype",
          render: (h, params) => {
            const v = params.row ? params.row.ntype : "";
            const text =
              v === 0 ? "收货实拍" : v === 1 ? "娃娃机出奖" : v === 2 ? "游戏出奖" : "";
            return h("span", text);
          },
        },
        {
          title: "创建时间",
          key: "createtime",
        },
        {
          title: "图片",
          key: "images",
          render: (h, params) => {
            const images =
              params.row && Array.isArray(params.row.images) ? params.row.images : [];
            if (!images.length) return h("span", "");

            const nodes = images.slice(0, 3).map((img, idx) => {
              const rawUrl = img && img.image_url ? img.image_url : "";
              const url = rawUrl ? formatOssUrl(rawUrl) : "";
              return h("img", {
                key: `${params.row && params.row.id ? params.row.id : "row"}_${idx}`,
                attrs: { src: url },
                style: {
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                  marginRight: "6px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  border: "1px solid #eee",
                },
                on: {
                  click: () => {
                    if (url) this.openPreview(url);
                  },
                },
              });
            });

            if (images.length > 3) {
              nodes.push(
                h(
                  "span",
                  {
                    style: {
                      color: "#999",
                    },
                  },
                  `+${images.length - 3}`
                )
              );
            }

            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              nodes
            );
          },
        },
        
      
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            const row = params.row || {};
            const children = [];

            if (row.nstatus === 0) {
              children.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small",
                    },
                    style: {
                      marginRight: "8px",
                    },
                    on: {
                      click: () => {
                        this.approveRow(row);
                      },
                    },
                  },
                  "通过"
                )
              );

              children.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    style: {
                      marginRight: "8px",
                    },
                    on: {
                      click: () => {
                        this.openRejectModal(row);
                      },
                    },
                  },
                  "拒绝"
                )
              );
            } else if (row.nstatus === 1) {
              children.push(h("span", "已通过"));
            } else if (row.nstatus === 2) {
              const reason = row && row.checktxt ? ` ${row.checktxt}` : "";
              children.push(
                h(
                  "span",
                  {
                    style: {
                      color: "#ed4014",
                    },
                  },
                  `已拒绝${reason}`
                )
              );
            }

           

            return h("div", children);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchPhone: "",
      current: 1,
      total: 0,
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    openPreview(url) {
      this.jpImageModal = true;
      this.jpImageLoading = false;
      this.jpImageUrl = url || "";
    },
    viewJpImage(row) {
      this.jpImageModal = true;
      this.jpImageLoading = false;
      this.jpImageUrl = "";

      const images = row && Array.isArray(row.images) ? row.images : [];
      const firstUrl = images && images[0] ? images[0].image_url : "";
      this.jpImageUrl = firstUrl ? formatOssUrl(firstUrl) : "";
    },

    openRejectModal(row) {
      this.rejectRowId = row && row.id != null ? row.id : null;
      this.rejectReason = "";
      this.rejectModal = true;
    },

    cancelReject() {
      this.rejectModal = false;
      this.rejectReason = "";
      this.rejectRowId = null;
    },

    submitReject() {
      if (!this.rejectRowId) {
        this.$Message.error("缺少id");
        this.rejectModal = false;
        return;
      }
      if (!this.rejectReason) {
        this.$Message.error("请选择拒绝原因");
        return;
      }

      cmsCleck({
        id: this.rejectRowId,
        nstatus: 2,
        checktxt: this.rejectReason,
      })
        .then(() => {
          this.$Message.success("已拒绝");
          this.cancelReject();
          this.queryGoods();
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error("操作失败");
        });
    },

    approveRow(row) {
      const id = row && row.id != null ? row.id : null;
      if (!id) {
        this.$Message.error("缺少id");
        return;
      }

      cmsCleck({
        id,
        nstatus: 1,
        checktxt: "",
      })
        .then(() => {
          this.$Message.success("已通过");
          this.queryGoods();
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error("操作失败");
        });
    },
  
    guanbimodal() {
      this.modal3 = false;
      this.modal4 = false;
    },
    cancelFenghao() {
      this.modal1 = false;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsShowList(params)
        .then((response) => {
          const payload =
            response && response.data && response.data.data
              ? response.data.data
              : response && response.data
                ? response.data
                : {};
          this.data9 = (payload && payload.list) || []; // 获取查询结果
          this.current = payload && payload.page ? payload.page : this.current; // 获取当前页
          this.total = payload && payload.total ? payload.total : 0; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      const params = {
        nstatus: this.nstatus === "" ? undefined : this.nstatus,
        ntype: this.ntype === "" ? undefined : this.ntype,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.roomid = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.nstatus = "";
      this.ntype = "";
      this.current = 1;
      this.queryGoods();
    },
   
    cancelRecharge() {
      this.modal2 = false; // 关闭弹窗
    },
    handleCurrencyTypeChange(value) {
      if (value === '礼品') {
        this.rechargeType = '充值';
        this.amount = '';
      } else {
        this.giftId = '';
        this.amount = 0;
      }
    },
  },
};
</script>
